<template>
    <b-modal
        ref="select-or-make-modal"
        cancel-variant="outline-secondary"
        size="lg"
        centered
        :title="title"
        hide-footer
        @hide="$emit('modalHide')"
    >
        <SelectOrMakeProduct
            :button-disabled="buttonDisabled"
            :search-disabled="searchDisabled"
            :modifier-function="modifierFunction"
            @input="(q) => $emit('input', q)"
            @selected="(p, numberOfUnits) => $emit('selected', p, numberOfUnits)"
            @created="created"
        >
            <template #additional-content>
                <slot name="additional-content"/>
            </template>
        </SelectOrMakeProduct>
    </b-modal>
</template>

<script>
import { BModal } from 'bootstrap-vue'
import SelectOrMakeProduct from "@core/components/product/SelectOrMakeProduct";

export default {
    components: {
        SelectOrMakeProduct, BModal,
    },
    props: {
        title: {
            default() {
                return this.$t('Component(SelectOrMakeProductModal):title');
            }
        },
        buttonDisabled: {
            default: false
        },
        searchDisabled: {
            default: false
        },
        modifierFunction: {
            default() {
                return (data) => data;
            }
        }
    },
    methods: {
        created(product, numberOfUnits) {
            this.$refs['select-or-make-modal'].hide();
            this.$emit('created', product, numberOfUnits);
        },
        show() {
            this.$refs['select-or-make-modal'].show();
        },
    },
}
</script>
